import * as angular from 'angular';
import ngRedux from 'ng-redux';
import 'angular-ui-router';

import CamerasComponent from './cameras.component';

export default angular
.module('fp:activationswizard:sensor:cameras', [])
        .component("awCameras", CamerasComponent);